module.exports = __webpack_public_path__ + "0a88144a4ca39dcc9b120b9030835137.fbx";